import Joi from 'joi'

import { UserNamePattern } from 'constants/index'

const ValidationSchema = Joi.object({
  driverId: Joi.number().required(),
  email: Joi.string()
    .trim()
    .email({ tlds: { allow: false } })
    .required()
    .label('Email'),
  firstName: Joi.string().trim().required().label('First Name'),
  lastName: Joi.string().trim().required().label('Last Name'),
  name: Joi.string().required().label('Driver Name'),
  username: Joi.string().trim().required().label('Username').pattern(UserNamePattern).messages({
    'string.pattern.base':
      'Username can contain only letters, numbers and these symbols: . _ @ + -',
  }),
})

export default ValidationSchema
